import { clearCookie } from "./cookies";

export const getSSOCookieName = (isWebView: boolean = false) => {
  return isWebView ? undefined : import.meta.env.VITE_SSO_COOKIE_NAME;
};

export const clearPingCookies = () => {
  const cookiesToRemove = ["access_token", "refresh_token"];

  const ssoCookieName = getSSOCookieName();
  if (ssoCookieName) {
    cookiesToRemove.push(ssoCookieName);
  }

  const domain = ".premierleague.com";
  cookiesToRemove.forEach((cookie: string) => clearCookie(cookie, domain));
};
